<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="timeout"
    :left="left"
    :right="right"
    :top="top"
    :bottom="bottom"
  >
    {{ text }}
  </v-snackbar>
</template>

<script>
export default {
  props: {
    // Whether to show the Snackbar
    value: {
      required: true,
      type: Boolean,
      default: false
    },
    // Text to show on Snackbar
    text: {
      required: true,
      type: String,
      default: ''
    },
    // The color of the Snackbar
    color: {
      required: false,
      type: String,
      default: 'primary'
    },
    // Position Snackbar to the left
    left: {
      required: false,
      type: Boolean,
      default: false
    },
    // Position Snackbar to the right
    right: {
      required: false,
      type: Boolean,
      default: false
    },
    // Position Snackbar to the top
    top: {
      required: false,
      type: Boolean,
      default: false
    },
    // Position Snackbar to the bottom
    bottom: {
      required: false,
      type: Boolean,
      default: false
    },
    timeout: {
      required: false,
      type: [String, Number],
      default: 4000
    }
  },
  computed: {
    show: {
      get: function () {
        return this.value
      },
      set: function (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
</style>
